import { makeAutoObservable } from 'mobx';
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';

dayjs.extend(duration);

export const SYNC_FREQUENCY = 10 * 60 * 1000;

export class AirflowSyncStore {
  countdownTime = '';

  private targetTime: dayjs.Dayjs | null = null;
  private timerInterval: NodeJS.Timeout | null = null;
  // same as dayjs mask
  private formatMask = 'm';

  constructor() {
    makeAutoObservable(this);
  }

  private updateTime = () => {
    if (!this.targetTime) {
      this.countdownTime = '';
      return;
    }

    const diffMs = this.targetTime.diff(dayjs());

    const timeDuration = dayjs.duration(diffMs);

    this.countdownTime = timeDuration.format(this.formatMask);

    if (diffMs <= 0) {
      this.clearTimer();
      return;
    }
  };

  setTargetTime = ({ latestSyncIso, formatMask = this.formatMask }: { latestSyncIso: string; formatMask?: string }) => {
    this.clearTimer();

    this.targetTime = dayjs(latestSyncIso);

    while (this.targetTime?.isBefore()) {
      this.targetTime = this.targetTime?.add(SYNC_FREQUENCY, 'milliseconds');
    }

    this.formatMask = formatMask;

    this.updateTime();
    this.timerInterval = setInterval(this.updateTime, 1000);
  };

  clearTimer = () => {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
      this.timerInterval = null;
    }
  };
}

export const airflowSyncStore = new AirflowSyncStore();
